import React from "react";
import * as S from "./styles";

export interface LogoDrawProps {
  size?: "sm" | "md" | "lg";
  responsive?: boolean;
}

const LogoDraw = ({ size, responsive = false }: LogoDrawProps) => {
  return (
    <S.Container size={size} responsive={responsive}>
      <svg
        width="49"
        height="61"
        viewBox="0 0 49 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30.5 4.06665H0V61H40.6666V14.2333L30.5 4.06665Z"
          fill="#3DA9FC"
        />
        <path
          d="M38.6333 0H8.1333V56.9333H48.7999V10.1667L38.6333 0Z"
          fill="#77C2FB"
        />
        <path
          d="M38.6333 10.1667V0L44.7333 6.1L48.8 10.1667H38.6333Z"
          fill="#3EA8F9"
        />
        <path
          d="M12.2 14.4168C11.1782 14.4168 10.35 15.2451 10.35 16.2668C10.35 17.2886 11.1782 18.1168 12.2 18.1168V14.4168ZM32.5333 18.1168C33.555 18.1168 34.3833 17.2886 34.3833 16.2668C34.3833 15.2451 33.555 14.4168 32.5333 14.4168V18.1168ZM12.2 18.1168H32.5333V14.4168H12.2V18.1168Z"
          fill="#FFFFFE"
        />
        <path
          d="M12.2 22.55C11.1782 22.55 10.35 23.3783 10.35 24.4C10.35 25.4218 11.1782 26.25 12.2 26.25V22.55ZM40.6666 26.25C41.6883 26.25 42.5166 25.4218 42.5166 24.4C42.5166 23.3783 41.6883 22.55 40.6666 22.55V26.25ZM12.2 26.25H40.6666V22.55H12.2V26.25Z"
          fill="#FFFFFE"
        />
        <path
          d="M12.2 30.6833C11.1782 30.6833 10.35 31.5116 10.35 32.5333C10.35 33.5551 11.1782 34.3833 12.2 34.3833V30.6833ZM40.6666 34.3833C41.6883 34.3833 42.5166 33.5551 42.5166 32.5333C42.5166 31.5116 41.6883 30.6833 40.6666 30.6833V34.3833ZM12.2 34.3833H40.6666V30.6833H12.2V34.3833Z"
          fill="#FFFFFE"
        />
        <path
          d="M12.2 38.8169C11.1782 38.8169 10.35 39.6451 10.35 40.6669C10.35 41.6886 11.1782 42.5169 12.2 42.5169V38.8169ZM40.6666 42.5169C41.6883 42.5169 42.5166 41.6886 42.5166 40.6669C42.5166 39.6451 41.6883 38.8169 40.6666 38.8169V42.5169ZM12.2 42.5169H40.6666V38.8169H12.2V42.5169Z"
          fill="#FFFFFE"
        />
        <path
          d="M12.2 46.9502C11.1782 46.9502 10.35 47.7784 10.35 48.8002C10.35 49.8219 11.1782 50.6502 12.2 50.6502V46.9502ZM24.3999 50.6502C25.4217 50.6502 26.2499 49.8219 26.2499 48.8002C26.2499 47.7784 25.4217 46.9502 24.3999 46.9502V50.6502ZM12.2 50.6502H24.3999V46.9502H12.2V50.6502Z"
          fill="#FFFFFE"
        />
      </svg>
    </S.Container>
  );
};

export default LogoDraw;
